import { render } from "./entry-collapse.vue?vue&type=template&id=72e3585d&scoped=true"
import script from "./entry-collapse.vue?vue&type=script&lang=js"
export * from "./entry-collapse.vue?vue&type=script&lang=js"

import "./entry-collapse.vue?vue&type=style&index=0&id=72e3585d&scoped=true&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72e3585d"],['__file',"vendor/wielink-application/shared/resources/vue/layouts/partials/sidebar/entry-collapse.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "72e3585d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('72e3585d', __exports__)) {
    console.log('reload')
    api.reload('72e3585d', __exports__)
  }
  
  module.hot.accept("./entry-collapse.vue?vue&type=template&id=72e3585d&scoped=true", () => {
    console.log('re-render')
    api.rerender('72e3585d', render)
  })

}


export default __exports__